import { render } from "./ContactStart.vue?vue&type=template&id=4cd05640"
import script from "./ContactStart.vue?vue&type=script&lang=js"
export * from "./ContactStart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__